import React from 'react';

function Close({ color = 'text-shuttle-grey', size = 'w-6 h-6' }) {
	return (
		<div className={`fill-current ${color} ${size} mr-2`}>
			<svg viewBox="0 0 16 16" version="1.1">
				<g id="Icons---monochrome" stroke="none" strokeWidth="1" fillRule="evenodd" fill="currentcolor">
					<g id="export">
						<rect id="box" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16" />
						<path
							d="M3.3055655,0.567145377 L7.59593898,4.85751886 C7.81909572,5.0806756 8.18090428,5.0806756 8.40406102,4.85751886 L12.6944345,0.567145377 C13.4506283,-0.189048459 14.6766608,-0.189048459 15.4328546,0.567145377 C16.1890485,1.32333921 16.1890485,2.54937166 15.4328546,3.3055655 L11.1424811,7.59593898 C10.9193244,7.81909572 10.9193244,8.18090428 11.1424811,8.40406102 L15.4328546,12.6944345 C16.1890485,13.4506283 16.1890485,14.6766608 15.4328546,15.4328546 C14.6766608,16.1890485 13.4506283,16.1890485 12.6944345,15.4328546 L8.40406102,11.1424811 C8.18090428,10.9193244 7.81909572,10.9193244 7.59593898,11.1424811 L3.3055655,15.4328546 C2.54937166,16.1890485 1.32333921,16.1890485 0.567145377,15.4328546 C-0.189048459,14.6766608 -0.189048459,13.4506283 0.567145377,12.6944345 L4.85751886,8.40406102 C5.0806756,8.18090428 5.0806756,7.81909572 4.85751886,7.59593898 L0.567145377,3.3055655 C-0.189048459,2.54937166 -0.189048459,1.32333921 0.567145377,0.567145377 C1.32333921,-0.189048459 2.54937166,-0.189048459 3.3055655,0.567145377 Z"
							id="close"
						/>
					</g>
				</g>
			</svg>
		</div>
	);
}

export default Close;
